<c-card *transloco="let t">
  <c-card-body class="px-2">


      <app-worker-reports-menu></app-worker-reports-menu>

      <div class="row">
        <div class="col-sm-8">
          <h3>{{ t('Report: Worker Connectivity View') }}</h3>
          <p>{{ t('View the app connectivity status of all the workers') }}</p>
        </div>
        <div class="col-sm-4 text-end">
          <div class="btn-group mb-2 " role="group">
            <a href="https://okalone.zendesk.com/hc/en-gb/articles/36291796901393-Understanding-App-Connectivity-in-OK-Alone" class="btn btn-primary" target="_new"><i class="fa fa-question-circle" aria-hidden="true"></i> {{ t('Help') }}</a> <br/>
            
            <button type="button" class="btn btn-light" aria-expanded="false" (click)="getWorkers()">
              <span *ngIf="!okService.loading"><i class="fa-solid fa-rotate-right"></i></span>
              <span *ngIf="okService.loading"><i class="fa-solid fa-spinner fa-spin"></i></span>
              {{ t('Refresh') }}
            </button>
          </div>
        </div>
      </div>

      
      <div class="card mb-2">
        <div class="card-header"data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="true" aria-controls="collapseExample">
          <i class="fa-solid fa-chevron-down"></i> {{ t('Filter Results') }}
        </div>
        <div class="show" id="collapseExample">
          <div class="card-body">

            <form cForm>

              <div class="row d-flex mb-2">
                <label  class="col-sm-2 col-form-label text-end"  for="search">
                  <b>{{ t('Search') }}</b>
                </label>
                <div class="col-sm-4">
                  <input cFormControl id="search" name="search" placeholder="{{ t('Search') }}" [(ngModel)]="filter.search"/>
                </div>
            </div>

              <div class="row d-flex mb-2">
                  <label  class="col-sm-2 col-form-label text-end"  for="monitors">
                    <b>{{ t('Monitor') }}</b>
                  </label>
                  <div class="col-sm-4">
                    <ng-select
                    [items]="monitors"
                    name="monitor"
                    [(ngModel)]="filter.monitors"
                    multiple="true"
                    bindLabel="name"
                    bindValue="id">
                    </ng-select>
                  </div>

                  <ng-container *ngIf="okService.groups.length > 0 && okService.hasFeature('groups')">
                    <label  class="col-sm-2 col-form-label text-end" for="groups">
                      <b>{{ t('Group') }}</b>
                    </label>
                  <div class="col-sm-4">
                    <ng-select
                    [items]="groups"
                    name="group"
                    [(ngModel)]="filter.groups"
                    multiple="true"
                    bindLabel="name"
                    bindValue="id">
                    </ng-select>
                  </div>
                </ng-container>

                </div>

              <div class="row d-flex justify-content-center mb-2">
                <div class="col-sm-3 d-flex justify-content-end">
                  <button cButton class="btn btn-info text-white" type="submit"  (click)="updateFilter()">
                    <i class="fa-solid fa-magnifying-glass"></i>
                    <span class="d-none d-lg-inline">
                      {{ t('Search') }}
                    </span>
                  </button>
                </div>
            &nbsp;&nbsp;&nbsp;&nbsp;
                <div class="col-sm-3">
                  <button cButton class="btn btn-light" type="submit"  (click)="clearFilter()">
                    <i class="fa-solid fa-xmark"></i>
                    <span class="d-none d-lg-inline">
                      {{ t('Clear Filter') }}
                    </span>
                  </button>
                </div>
            </div>

            </form>

          </div>
        </div>
      </div>

      <c-row *ngIf="workers">
        <c-col>

          <table
          [hover]="true"
          [responsive]="true"
          [striped]="true"
          align="middle"
          cTable
          class="mb-0 border"
          >
            <thead>
              <tr>
                <th scope="col">{{ t('PIN') }}</th>
                <th scope="col">{{ t('Worker Name') }}</th>
                <th scope="col">{{ t('Connectivity Status') }}</th>
                <th scope="col">{{ t('Last Signal Strength') }}</th>
                <th scope="col">{{ t('Last Battery') }}</th>
                <th scope="col" *ngIf="showMotionColumn">{{ t('Motion') }}</th>
                <th scope="col">{{ t('Time Since Last Sync') }}</th>
                <th scope="col">{{ t('Current Status') }}</th>
                <th scope="col">{{ t('Device') }}</th>
                <th scope="col">{{ t('Notes') }}</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let worker of workers">
                <td>
                  <c-badge color="info">
                    {{ u.formatWorkerPin(worker.pin) }}
                  </c-badge>
                </td>
                <td>{{ worker.name }}</td>
                <td>
                  <c-badge [color]="worker.connectivity.status.class">
                    {{ worker.connectivity.status.identifier }}
                  </c-badge>
                </td>
                <td>
                  <c-badge [color]="worker.device.signal.color" *ngIf="worker.device.signal.strength">
                    {{ worker.device.signal.label }}
                  </c-badge>
                  <c-badge color="secondary" *ngIf="!worker.device.signal.strength">
                    Unavailable
                  </c-badge>
                </td>
                <td>
                  <c-badge [color]="worker.device.battery.color" *ngIf="worker.device.battery.percentage">
                    {{ worker.device.battery.label }}
                  </c-badge>
                </td>
                <td *ngIf="showMotionColumn" class="text-center align-middle">
                  <div *ngIf="motionHeartbeatVisible(worker.connectivity?.motion_heartbeat)" class="d-flex flex-column align-items-center gap-1">
                    <c-badge [color]="motionHeartbeatBadgeColor(worker.connectivity.motion_heartbeat.minutes_since)">
                      {{ motionHeartbeatLabel(worker.connectivity.motion_heartbeat) }}
                    </c-badge>
                  </div>
                  <span *ngIf="!motionHeartbeatVisible(worker.connectivity?.motion_heartbeat) && !worker.connectivity?.motion_heartbeat">—</span>
                </td>
                <td>
                  <div class="d-flex flex-column gap-1">
                    <span>{{ worker.connectivity.last_sync.formatted_time_since }}</span>
                    <small class="text-body-secondary">{{ worker.connectivity.last_sync.time }}</small>
                  </div>
                </td>
                <td>
                  <c-badge [color]="worker.status.color">
                    {{ worker.status.label }}
                  </c-badge>
                </td>
                <td>{{ worker.device.info }}</td>
                <td>{{ worker.connectivity.notes }}</td>
                <td>
                  <button color="info" cButton class="me-1 btn-sm text-white" routerLink="/mgmt/worker/{{worker.worker_id}}">
                    {{ t('Edit') }}
                  </button>
                </td>
              </tr>

            </tbody>
          </table>

        </c-col>
      </c-row>


    </c-card-body>
  </c-card>
  